"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81969],{

/***/ 63689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": function() { return /* binding */ DateDescendingOrder; },
/* harmony export */   "ar": function() { return /* binding */ DateAscendingOrder; },
/* harmony export */   "bI": function() { return /* binding */ PhoneNumberValidator; },
/* harmony export */   "dl": function() { return /* binding */ NumberWithCommas; },
/* harmony export */   "nO": function() { return /* binding */ CheckEmail; },
/* harmony export */   "qn": function() { return /* binding */ UseCountDescendingOrder; },
/* harmony export */   "wz": function() { return /* binding */ UsedTimeDescendingOrder; }
/* harmony export */ });
/* unused harmony exports NumberFormatCustom, RankingOrder */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);






/* 숫자 콤마 추가 */ var NumberWithCommas = function(x) {
    if (x) {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return x.toString().replace(regexp, ",");
    } else {
        return x;
    }
};
/* 숫자만 표기 & 콤마 표시 */ var NumberFormatCustom = function(props) {
    var inputRef = props.inputRef, onChange = props.onChange, other = _object_without_properties(props, [
        "inputRef",
        "onChange"
    ]);
    return /*#__PURE__*/ _jsx(NumberFormat, _object_spread_props(_object_spread({}, other), {
        getInputRef: inputRef,
        onValueChange: function(values) {
            onChange({
                target: {
                    name: props.name,
                    value: values.value
                }
            });
        },
        thousandSeparator: true,
        isNumericString: true
    }));
};
/* 전화번호 유효성 체크 */ var PhoneNumberValidator = function(args) {
    if (/^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/.test(args)) {
        return true;
    }
    return false;
};
/* 이메일 유효성 체크 */ var CheckEmail = function(str) {
    var reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    if (!reg_email.test(str)) {
        return false;
    } else {
        return true;
    }
};
/* 날짜 내림차순 정렬 */ var DateDescendingOrder = function(a, b) {
    var dateA = new Date(a.createdAt).getTime();
    var dateB = new Date(b.createdAt).getTime();
    return dateA < dateB ? 1 : -1;
};
/* 날짜 내림차순 정렬 */ var UsedTimeDescendingOrder = function(a, b) {
    var dateA = new Date(a.usedTime).getTime();
    var dateB = new Date(b.usedTime).getTime();
    return dateA < dateB ? 1 : -1;
};
/* 날짜 오름차순 정렬 */ var DateAscendingOrder = function(a, b) {
    var dateA = new Date(a.createdAt).getTime();
    var dateB = new Date(b.createdAt).getTime();
    return dateA > dateB ? 1 : -1;
};
/* 랭킹 정렬 */ var RankingOrder = function(a, b) {
    return a.useCount > b.useCount ? 1 : -1;
};
/* 사용횟수 내림차순 정렬 */ var UseCountDescendingOrder = function(a, b) {
    return a.useCount < b.useCount ? 1 : -1;
};


/***/ }),

/***/ 37276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ initKakao; },
/* harmony export */   "L": function() { return /* binding */ shareKakao; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initKakao = function() {
    if (window.Kakao) {
        var kakao = window.Kakao;
        if (!kakao.isInitialized()) {
            kakao.init("37d6f07b8ece67b826f25e89654bf4e1");
        }
    }
};
var shareKakao = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(linkUrl, title, description) {
        var basicTitle, basicDescription, image, sendTitle, sendDescription, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    basicTitle = "인공지능 서비스 마켓 아이소";
                    basicDescription = "이미지, 데이터 분석 등 다양한 아이소 앱을 사용해보세요.";
                    image = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/apps%2Fpreview%2Faiso_logo.jpg?alt=media&token=e6014be6-b135-4fdf-bac2-9e86295ffac5";
                    sendTitle = title ? title : basicTitle;
                    sendDescription = description ? description : basicDescription;
                    _tmp = {};
                    /* sendDefault */ return [
                        4,
                        window.Kakao.Link.sendDefault((_tmp.objectType = "feed", _tmp.content = {
                            title: sendTitle,
                            description: sendDescription,
                            imageUrl: image,
                            imageWidth: 1500,
                            imageHeight: 600,
                            link: {
                                mobileWebUrl: linkUrl,
                                webUrl: linkUrl
                            }
                        }, _tmp.buttons = [
                            {
                                title: "아이소로 이동하기",
                                link: {
                                    mobileWebUrl: linkUrl,
                                    webUrl: linkUrl
                                }
                            }, 
                        ], _tmp))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function shareKakao(linkUrl, title, description) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 71094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52205);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);




var Paginations = function(param) {
    var items = param.items, onChangePage = param.onChangePage, nowPage = param.nowPage;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), pager = ref[0], setPager = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (nowPage) {
            setPage(nowPage);
        } else {
            setPage(1);
        }
        /* 스크롤 이동 */ window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    // setPage(1);
    }, [
        items
    ]);
    var setPage = function(page) {
        var tempItems = items;
        var tempPager = pager;
        if (page < 1 || page > pager.totalPages) {
            return;
        }
        // get new pager object for specified page
        tempPager = getPager(tempItems.length, page, 8, 10);
        // get new page of items from items array
        var pageOfItems = tempItems.slice(tempPager.startIndex, tempPager.endIndex + 1);
        // update state
        setPager(tempPager);
        if (nowPage) {
            settings.aisoMarketPage = page;
        }
        // call change page function in parent component
        onChangePage(pageOfItems, tempPager.startIndex);
        /* 스크롤 이동 */ window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var getPager = function(totalItems, currentPage, pageSize, maxPagesToDisplay) {
        // default to first page
        currentPage = currentPage || 1;
        // default page size is 10
        pageSize = pageSize || 10;
        // default max pages to display is 10
        maxPagesToDisplay = maxPagesToDisplay || 10;
        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);
        var startPage, endPage;
        if (totalPages <= maxPagesToDisplay) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            var halfwayPoint = Math.ceil(maxPagesToDisplay / 2);
            var pastHalfwayPoint = Math.floor(maxPagesToDisplay / 2) + 1;
            var beforeHalfwayPoint = halfwayPoint - 1;
            if (currentPage <= pastHalfwayPoint) {
                startPage = 1;
                endPage = maxPagesToDisplay;
            } else if (currentPage + beforeHalfwayPoint >= totalPages) {
                startPage = totalPages - (maxPagesToDisplay - 1);
                endPage = totalPages;
            } else {
                startPage = currentPage - halfwayPoint;
                endPage = currentPage + beforeHalfwayPoint;
            }
        }
        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        // create an array of pages to ng-repeat in the pager control
        var pages = [];
        Array.from({
            length: endPage + 1 - startPage
        }, function(v, i) {
            return pages.push(startPage + i);
        });
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    };
    if (!pager.pages || pager.pages.length <= 1) {
        // don't display pager if there is only 1 page
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "rounded-separated pagination-primary justify-center mt-20",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Prev */ .Z.Prev, {
                className: pager.currentPage === 1 ? "disabled" : "",
                onClick: function() {
                    return setPage(pager.currentPage - 1);
                }
            }),
            pager.pages.map(function(page, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: pager.currentPage === page ? "page-item active" : "page-item",
                    style: {
                        cursor: "pointer"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "page-link",
                        onClick: function() {
                            return setPage(page);
                        },
                        children: page
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Next */ .Z.Next, {
                className: pager.currentPage === pager.totalPages ? "disabled" : "",
                onClick: function() {
                    return setPage(pager.currentPage + 1);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Paginations);


/***/ }),

/***/ 37915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserName = function(email) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), name = ref[0], setName = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().name !== "") setName(docValue.data().name);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return name;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserName);


/***/ }),

/***/ 64410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79794);




var UserPhoto = function(email) {
    /* photo url 저장 */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("/images/market/no-img.png"), url = ref[0], setUrl = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var docRef, docValue, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_1__/* .projectFirestore.collection */ .H.collection("users").doc(email);
                    return [
                        4,
                        docRef.get()
                    ];
                case 2:
                    docValue = _state.sent();
                    if (docValue.exists) {
                        if (docValue.data().photo !== "") setUrl(docValue.data().photo);
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        email
    ]);
    return url;
};
/* harmony default export */ __webpack_exports__["Z"] = (UserPhoto);


/***/ }),

/***/ 81268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5566);
/* harmony import */ var components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4534);
/* harmony import */ var _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32692);





var MaterialModal = function(param) {
    var children = param.children, open = param.open, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        "aria-labelledby": "spring-modal-title",
        "aria-describedby": "spring-modal-description",
        className: "popup-wrap",
        open: open,
        onClose: closeModal,
        closeAfterTransition: true,
        disableScrollLock: true,
        BackdropComponent: _material_ui_core_Backdrop__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
        outline: 0,
        BackdropProps: {
            timeout: 500
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ModalFade__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            in: open,
            className: "center2",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MaterialModal);


/***/ }),

/***/ 4534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_spring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39920);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







/* Material-UI 모달 Fade */ var ModalFade = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function Fade(props, ref) {
    var open = props.in, children = props.children, onEnter = props.onEnter, onExited = props.onExited, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "in",
        "children",
        "onEnter",
        "onExited"
    ]);
    var style = (0,react_spring__WEBPACK_IMPORTED_MODULE_2__.useSpring)({
        config: {
            duration: 10
        },
        from: {
            opacity: 0
        },
        to: {
            opacity: open ? 1 : 0
        },
        onStart: function() {
            if (open && onEnter) {
                onEnter();
            }
        },
        onRest: function() {
            if (!open && onExited) {
                onExited();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_spring__WEBPACK_IMPORTED_MODULE_2__.animated.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ref: ref,
        style: style
    }, other), {
        children: children
    }));
});
ModalFade.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().element),
    in: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool.isRequired),
    onEnter: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func),
    onExited: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalFade);


/***/ }),

/***/ 76195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83792);
/* harmony import */ var _material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44704);
/* harmony import */ var _material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66081);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34950);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37276);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81268);






// ShareIcon








var ShareModal = function(param) {
    var open = param.open, handleClose = param.handleClose, path = param.path, title = param.title, description = param.description;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // const basicUrl = "aiso-api.du.r.appspot.com";
    var basicUrl = "aiso.ai";
    var linkUrl = path ? basicUrl.concat(path) : basicUrl.concat(router.asPath);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .initKakao */ .$)();
    }, []);
    var handleKakaoShare = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
            var sendLinkUrl;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                sendLinkUrl = "https://".concat(linkUrl);
                (0,components_KakaoShare__WEBPACK_IMPORTED_MODULE_5__/* .shareKakao */ .L)(sendLinkUrl, title, description);
                return [
                    2
                ];
            });
        });
        return function handleKakaoShare() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: open,
        closeModal: handleClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content max-w-xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                            className: "text-333 font-gmarket-medium text-2xl font-bold mb-4",
                            children: "Share"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            // const linkUrl = `aiso-api.du.r.appspot.com${router.asPath}`;
                                            window.open("https://www.facebook.com/sharer.php?u=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "face-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Facebook__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "facebook"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: handleKakaoShare,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "kakao-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        width: "40px",
                                                        height: "40px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        className: "p-1",
                                                        src: "/images/market/kakaotalk.svg",
                                                        alt: ""
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Kakao Talk"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "share-card p-3",
                                        onClick: function() {
                                            handleClose();
                                            window.open("https://twitter.com/intent/tweet/?url=" + encodeURIComponent(linkUrl));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "twitter-share-icon",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Twitter__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    fontSize: "large"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                children: "Twitter"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_4__.CopyToClipboard, {
                                        text: "https://".concat(linkUrl),
                                        onCopy: function() {
                                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_3__/* .BasicAlert */ .N)("클립보드에 복사되었습니다.");
                                            handleClose();
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "share-card p-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "twitter-share-icon",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                                        fontSize: "large"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mb-0 font-gmarket-medium text-xs text-888 mt-3",
                                                    children: "Copy Link"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);


/***/ }),

/***/ 28722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58365);



var SkeletonDataAnalysis = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col sm:flex-row items-center aiso-data-card aiso-shadow mb-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full sm:w-2/12 cursor-pointer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "img-cover-box h-48",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            animation: "wave",
                            variant: "rect",
                            height: 200,
                            width: "100%"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full sm:w-10/12 py-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex justify-between items-center px-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-5/6 px-3 cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            animation: "wave",
                                            height: 20,
                                            width: 80
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "truncate-1-lines font-gmarket-medium text-888 mt-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                animation: "wave",
                                                height: 15,
                                                width: "80%",
                                                style: {
                                                    marginBottom: 6
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "z-50 px-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        animation: "wave",
                                        variant: "rect",
                                        height: 40,
                                        width: 40
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex justify-between items-end px-3 mt-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex justify-start items-center px-3 cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "img-cover-box w-10 h-10 rounded-full border",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        animation: "wave",
                                                        variant: "circle",
                                                        width: 40,
                                                        height: 40
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "ml-2",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        animation: "wave",
                                                        height: 20,
                                                        width: 80
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                        animation: "wave",
                                                        height: 20,
                                                        width: 100
                                                    }),
                                                    " "
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xs text-333 font-gmarket-medium",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            animation: "wave",
                                            height: 10,
                                            width: "20%"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonDataAnalysis);


/***/ }),

/***/ 81969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98105);
/* harmony import */ var components_Paginations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71094);
/* harmony import */ var components_UserPhoto__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64410);
/* harmony import */ var components_UserName__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37915);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79794);
/* harmony import */ var components_Function__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63689);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53093);
/* harmony import */ var components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76195);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(84501);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core_Select__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(94924);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85639);
/* harmony import */ var components_skeleton_SkeletonDataAnalysis__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28722);
/** @format */ 







// import useSettings from "stores/settings";
// import { useRouter } from "next/router";


// import { PreviewStorageUrl } from "components/PreviewStorageUrl";
// import AppLikeCount from "components/AppLikeCount";




// Modal



// Search




// DotMenu


var AllDataAnalysisList = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_3__/* .observer */ .Pi)(function(param) {
    var category = param.category;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), loading = ref[0], setLoading = ref[1];
    /* 페이지네이션 */ var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), pageOfItems = ref1[0], setPageOfItems = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), startIndex = ref2[0], setStartIndex = ref2[1];
    // const [page, setPage] = useState(settings.aisoMarketPage);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), page = ref3[0];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), contentsData = ref4[0], setContentsData = ref4[1];
    // const [dataAnalysisDatas, setDataAnalysisDatas] = useState(null);
    /* 검색 관련 데이터 */ var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("use"), selectMenu = ref5[0], setSelectMenu = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), searchData = ref6[0], setSearchData = ref6[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
        var datas, collectionRef, collectionValue, tempDatas, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    datas = [];
                    collectionRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("market").doc("public").collection("app");
                    return [
                        4,
                        collectionRef.get()
                    ];
                case 1:
                    collectionValue = _state.sent();
                    collectionValue.forEach(function(doc) {
                        /* 완성되지 않은 앱은 목록에서 제거 */ if (doc.data().status === "앱 배포완료" && doc.data().visible && doc.data().category === "dataAnalysis") {
                            datas.push((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, doc.data()));
                        }
                    });
                    tempDatas = datas.sort(components_Function__WEBPACK_IMPORTED_MODULE_8__/* .DateDescendingOrder */ .Zb);
                    // setDataAnalysisDatas(tempDatas);
                    /* 앱 ORDER BY  - 기본 new */ if (selectMenu === "recommend") {
                        /* 우선 내림 차순으로 넣어놨는데 나중에 추천으로 바꿔야함. */ tempDatas.sort(components_Function__WEBPACK_IMPORTED_MODULE_8__/* .DateDescendingOrder */ .Zb);
                    }
                    if (selectMenu === "use") {
                        tempDatas.sort(components_Function__WEBPACK_IMPORTED_MODULE_8__/* .UseCountDescendingOrder */ .qn);
                    }
                    if (selectMenu === "old") {
                        tempDatas.sort(components_Function__WEBPACK_IMPORTED_MODULE_8__/* .DateAscendingOrder */ .ar);
                    }
                    tempDatas = tempDatas.filter(function(f) {
                        return f.appName.indexOf(searchData) !== -1 || f.email.indexOf(searchData) !== -1 || f.userName.indexOf(searchData) !== -1;
                    });
                    if (category === "all") {
                        setContentsData(tempDatas);
                    } else if (category === "데이터분석") {
                        setContentsData(tempDatas.slice(1));
                    }
                    setLoading(false);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        category,
        searchData,
        selectMenu
    ]);
    /* 페이지네이션 */ var onChangePage = function(pageOfItems, startIndex) {
        setPageOfItems(pageOfItems);
        setStartIndex(startIndex);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchArea, {
                selectMenu: selectMenu,
                setSelectMenu: setSelectMenu,
                setSearchData: setSearchData
            }),
            loading ? Array.from({
                length: 4
            }).map(function(m, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_skeleton_SkeletonDataAnalysis__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}, i);
            }) : contentsData && contentsData.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-12 py-3 sm:py-0",
                            children: pageOfItems.map(function(m, index) {
                                return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(MarketCard, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, m), {
                                    key: startIndex + index
                                }));
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Paginations__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        items: contentsData,
                        onChangePage: onChangePage,
                        nowPage: page
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "center w-full py-32",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: "등록된 앱이 없습니다."
                })
            })
        ]
    });
});
/* Card Component */ var MarketCard = function(param) {
    var appId = param.appId, email = param.email, appName = param.appName, price = param.price, createdAt = param.createdAt, oneLineContent = param.oneLineContent, useCount = param.useCount, imageUrl = param.imageUrl;
    /* preview 가져오기 */ /* 사용자 프로필 가져오기 */ var photoUrl = (0,components_UserPhoto__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(email);
    var name = (0,components_UserName__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(email);
    //   /* 좋아요 수 체크 */
    //   const likeCount = AppLikeCount(email, appId);
    /* Modal */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full mb-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h-full flex flex-col sm:flex-row items-center aiso-data-card",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: {
                        pathname: "/user/dataAnalysis/[id]",
                        query: {
                            id: appId
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full min-h-full sm:w-4/12 md:w-3/12 xl:w-2/12 cursor-pointer",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "img-cover-box data-img-radius",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: imageUrl ? PreviewStorageUrl(imageUrl) : "/images/market/no-img.png"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full h-full sm:w-8/12 md:w-9/12 xl:w-10/12 flex flex-col justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex justify-between items-center px-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: {
                                    pathname: "/user/dataAnalysis/[id]",
                                    query: {
                                        id: appId
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full px-3 cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "truncate-2-lines text-333 text-xl font-bold mt-4",
                                            children: appName
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "truncate-1-lines text-333 text-base mt-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: oneLineContent
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full flex justify-between items-end mt-4 mb-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-black text-base",
                                                    children: [
                                                        useCount ? useCount : "0",
                                                        " 회 사용"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-black text-base font-bold",
                                                    children: [
                                                        price,
                                                        " Credit"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex justify-between items-end px-3 py-2 data-card-footer",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "w-full flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: {
                                            pathname: "/user/profile/[id]",
                                            query: {
                                                id: email
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-start items-center whitespace-pre-line break-all",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "img-cover-box w-11 h-11 rounded-full bg-white border-2 border-white",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                            src: photoUrl,
                                                            alt: "profile"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "ml-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "truncate-1-lines mb-0 text-black font-gmarket-medium text-sm",
                                                            children: name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "mb-0 text-333 font-gmarket-medium text-xs",
                                                            children: createdAt.substring(0, 16)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "z-50 px-3 ",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                color: "primary",
                                                onClick: handleOpen,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Share__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    className: "text-black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_ShareModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                open: open,
                                                handleClose: handleClose,
                                                path: "/user/dataAnalysis/".concat(appId),
                                                title: appName,
                                                description: oneLineContent
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* Search Area */ var SearchArea = function(param) {
    var selectMenu = param.selectMenu, setSelectMenu = param.setSelectMenu, setSearchData = param.setSearchData;
    var handleChange = function(event) {
        setSelectMenu(event.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12 col-sm-8 col-md-9 col-xl-10 mb-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Autocomplete__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                        id: "free-solo-demo",
                        freeSolo: true,
                        options: [],
                        className: "search-input",
                        renderInput: function(params) {
                            setSearchData(params.inputProps.value);
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, params), {
                                margin: "normal",
                                variant: "outlined",
                                placeholder: "Search"
                            }));
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-12 col-sm-4 col-md-3 col-xl-2 mb-3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        variant: "outlined",
                        className: "search-input",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_Select__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            labelId: "demo-simple-select-outlined-label",
                            id: "demo-simple-select-outlined",
                            onChange: handleChange,
                            displayEmpty: true,
                            value: selectMenu,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    value: "new",
                                    children: "최신순"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    value: "use",
                                    children: "사용횟수순"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    value: "old",
                                    children: "오래된순"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AllDataAnalysisList);
var PreviewStorageUrl = function(previewInput) {
    var previewInputFile = "/images/market/no-img.png";
    if (previewInput) previewInputFile = "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewInput) + "?alt=media";
    return previewInputFile;
};


/***/ })

}]);